<template>
  <div v-if="visibleItems.length" class="social-dock">
    <a
      v-for="item in visibleItems"
      :key="item.key"
      class="social-dock__btn"
      :class="`social-dock__btn--${item.key}`"
      :href="item.url"
      target="_blank"
      rel="noopener noreferrer"
      :title="item.label"
      :aria-label="item.label"
    >
      <i :class="item.icon"></i>
    </a>
  </div>
</template>

<script>
import SettingsHttp from "@/http/SettingsHttp";

const DEFAULT_WA =
  "https://wa.me/5562996363892?text=Ol%C3%A1%2C%20Preciso%20de%20ajuda%20para%20criar%20minha%20rifa%3F";

export default {
  name: "FloatSocialDock",
  data() {
    return {
      settings: {
        social_whatsapp_url: DEFAULT_WA,
        social_whatsapp_group_url: "",
        social_instagram_url: "",
        social_youtube_url: "",
        social_whatsapp_enabled: true,
        social_whatsapp_group_enabled: false,
        social_instagram_enabled: false,
        social_youtube_enabled: false,
      },
    };
  },
  computed: {
    visibleItems() {
      const items = [];
      if (this.settings.social_whatsapp_enabled && this.settings.social_whatsapp_url) {
        items.push({
          key: "whatsapp",
          label: "Suporte WhatsApp",
          url: this.settings.social_whatsapp_url,
          icon: "fab fa-whatsapp",
        });
      }
      if (this.settings.social_whatsapp_group_enabled && this.settings.social_whatsapp_group_url) {
        items.push({
          key: "whatsapp-group",
          label: "Grupo WhatsApp",
          url: this.settings.social_whatsapp_group_url,
          icon: "fas fa-users",
        });
      }
      if (this.settings.social_instagram_enabled && this.settings.social_instagram_url) {
        items.push({
          key: "instagram",
          label: "Instagram",
          url: this.settings.social_instagram_url,
          icon: "fab fa-instagram",
        });
      }
      if (this.settings.social_youtube_enabled && this.settings.social_youtube_url) {
        items.push({
          key: "youtube",
          label: "YouTube",
          url: this.settings.social_youtube_url,
          icon: "fab fa-youtube",
        });
      }
      return items;
    },
  },
  mounted() {
    this.loadSettings();
    window.addEventListener("rifa365:platform-settings-updated", this.loadSettings);
  },
  beforeUnmount() {
    window.removeEventListener("rifa365:platform-settings-updated", this.loadSettings);
  },
  methods: {
    async loadSettings() {
      try {
        const res = await SettingsHttp.getSettings();
        if (res.data) {
          this.settings = {
            social_whatsapp_url: res.data.social_whatsapp_url || DEFAULT_WA,
            social_whatsapp_group_url: res.data.social_whatsapp_group_url || "",
            social_instagram_url: res.data.social_instagram_url || "",
            social_youtube_url: res.data.social_youtube_url || "",
            social_whatsapp_enabled:
              res.data.social_whatsapp_enabled === undefined
                ? true
                : !!res.data.social_whatsapp_enabled,
            social_whatsapp_group_enabled: !!res.data.social_whatsapp_group_enabled,
            social_instagram_enabled: !!res.data.social_instagram_enabled,
            social_youtube_enabled: !!res.data.social_youtube_enabled,
          };
        }
      } catch (e) {
        // fallback: keeps default WhatsApp
      }
    },
  },
};
</script>

<style scoped>
.social-dock {
  position: fixed;
  right: 28px;
  bottom: 28px;
  top: auto;
  transform: none;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.social-dock__btn {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.45rem;
  text-decoration: none;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.18);
  border: 3px solid #fff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.social-dock__btn:hover {
  transform: scale(1.08);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.22);
  color: #fff;
}

.social-dock__btn--whatsapp,
.social-dock__btn--whatsapp-group {
  background: linear-gradient(145deg, #25d366, #128c7e);
}

.social-dock__btn--whatsapp-group {
  font-size: 1.15rem;
}

.social-dock__btn--instagram {
  background: linear-gradient(145deg, #f58529, #dd2a7b 45%, #8134af);
}

.social-dock__btn--youtube {
  background: linear-gradient(145deg, #ff4e45, #c4302b);
}

@media (max-width: 768px) {
  .social-dock {
    right: 14px;
    bottom: 110px;
    top: auto;
    transform: none;
  }
  .social-dock__btn {
    width: 48px;
    height: 48px;
    font-size: 1.25rem;
  }
}
</style>
